import axios from "infra/http";
import { useQuery } from "react-query";
import { TimelineLog } from "ui/components/TimelineLogs";

function useHistoricoArrecadacao(id?: string) {
  return useQuery(
    `/v1/arrecadacao/${id}/historico`,
    async () => {
      if (!id) {
        return null;
      }
      const res = await axios.get<TimelineLog[]>(
        `/v1/arrecadacao/${id}/historico`
      );

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useHistoricoArrecadacao;
